/* IBM Confidential‌ - OCO Source Materials‌ - (C) COPYRIGHT IBM CORP. 2020-2021 - The source code for this program is not published or otherwise‌ divested of its trade secrets, irrespective of what has been‌ deposited with the U.S. Copyright Office. */

import {NavUrlHandler} from "../handlers/NavUrlHandler";
import { NavConfig } from "../utils";

export class NavButtonClickService {

    constructor(projectContainer) {
        this.projectContainer = projectContainer;
    }

    selectProjectMenuItem(id, isFromBrowserAction) {
        this.navButtonClick(id, this.projectContainer.projectContainerHierarchyListItemHandler, isFromBrowserAction);
    }

    navButtonClick(menuId, hierarchyListItemHandler, isFromBrowserAction) {
        
        //Retrieve valid menu item.
        let menuItem = this.projectContainer.props.handleValidMenuItem(menuId, hierarchyListItemHandler);

        //Handle url and history name
        let navUrlHandler = new NavUrlHandler(menuItem, this.projectContainer.state.currentProjectId);
        navUrlHandler.handle();
        let menuItemUrl = navUrlHandler.getMenuItemUrl();
        let historyName = navUrlHandler.getHistoryName();

        let triNavigationSrc = this.projectContainer.state.triNavigationSrc;
        let sitemapMenuItemsToDisplay = this.projectContainer.state.sitemapMenuItemsToDisplay;
        let sitemapMenuItemIdsToDisplay = this.projectContainer.state.sitemapMenuItemIdsToDisplay;      
        let urlHashPart = navUrlHandler.getHashPart();
        let isInLineUXApp = false;

        //Page title - Do not update if we are opening in new window.
        if (!menuItem.isOpenInNewWindow) {
          document.title = menuItem.label + " - " + NavConfig.getNavConfigData().headerTitle
        }
        
        //Is this a nav page.
        if (menuItem.isNavPage) {

            //Hide landing page
            this.projectContainer.hideLandingPage();
            triNavigationSrc = '';

            //Check if this is the sitemap
            if (menuItem.name === 'sysSiteMap') {
                sitemapMenuItemsToDisplay = hierarchyListItemHandler.getSiteMapMenuItems();
            } else {
                //Standard nav page
                sitemapMenuItemsToDisplay = menuItem.children;
            }
            sitemapMenuItemIdsToDisplay = hierarchyListItemHandler.getListItemIds();

            //Browser history
            this.projectContainer.props.navRoutingHandler.handleRoutingHistory(menuItem.name, historyName, isFromBrowserAction);
            //Dispatch event for GWT history handling
            if (process.env.NODE_ENV!=='development') {
                this.projectContainer.dispatchEnhancedNavigateEvent(window.document.querySelector("#triNavigation"), 'triEnhancedNavigateSitemapEvent', historyName);
            }
        } else {
            //Check if inline ux app
            if (menuItemUrl.startsWith('/p/web/') && !menuItem.isOpenInNewWindow) {
                isInLineUXApp = true;
            } 
            //Set the iFrame source.
            triNavigationSrc = this.projectContainer.props.tririgaContextUrl + menuItemUrl;
        }

        //Handle nav click button state
        this.projectContainer.handleNavButtonClickState(menuItem, triNavigationSrc, sitemapMenuItemsToDisplay, sitemapMenuItemIdsToDisplay, isFromBrowserAction, urlHashPart, isInLineUXApp);

        //Browser history for dev mode.
        //Production mode handles routing history on triNavigation frame events.
        if (process.env.NODE_ENV==='development' && !menuItem.isNavPage) {
            this.projectContainer.props.navRoutingHandler.handleRoutingHistory(menuItem.name, historyName, isFromBrowserAction);
        }
    }
}